// GA
import ReactGA from "react-ga4";
// styling
import "./style.scss";
import "leaflet/dist/leaflet.css";
import "swiper/css";
import "swiper/css/navigation";
// libs styles
import "swiper/css";
import "swiper/css/effect-fade";
import "react-toastify/dist/ReactToastify.css";
// utils
import { lazy, Suspense } from "react";
import { preventDefault } from "@utils/helpers";
// hooks
import { useEffect } from "react";
// context
import { BidModalContextAPI } from "@contexts/bidModalContext";
import { SidebarContextAPI } from "@contexts/sidebarContext";
import { AuthAPI } from "@contexts/authContext";
// components
import LoadingScreen from "@components/LoadingScreen";
import AppLayout from "@components/AppLayout";
import { Routes, Route } from "react-router-dom";
import ScrollToTop from "@components/ScrollToTop";
import Invest from "@pages/Invest";
import CookieComp from "@components/CookieConsent";
import Policy from "@pages/Policy";
import Comic from "@components/Comic";
import CreatePage from "@pages/CreatePage";
import EditPage from "@pages/EditPage";
import StoryBoard from "@pages/StoryBoard";
import Community from "@pages/Community";
import CommingSoon from "@pages/CommingSoon";
import FacebookShare from "@pages/FacebookShare";
//import ThankYou from "@pages/ThankYou";
import ThankYouPage from "@pages/Thank-you";
import Interest from "@pages/Interest";
import { ProtectedRoute } from "@layout/ProtectedRoute/ProtectedRoute";

// pages
const Home = lazy(() => import("@pages/Home"));
const ExploreGrid = lazy(() => import("@pages/ExploreGrid"));
const Author = lazy(() => import("@pages/Author"));
const Ranking = lazy(() => import("@pages/Ranking"));
const Login = lazy(() => import("@pages/Login"));
const Signup = lazy(() => import("@pages/Signup"));
const About = lazy(() => import("@pages/About"));
const Contacts = lazy(() => import("@pages/Contacts"));
const PageNotFound = lazy(() => import("@pages/PageNotFound"));
const EmailVerification = lazy(() => import("@pages/EmailVerification"));
const ForgotPassword = lazy(() => import("@pages/ForgotPassword"));
const FeaturedComix = lazy(() => import("@pages/FeaturedComix"));
const Help = lazy(() => import("@pages/Help"));
const PaymentHistory = lazy(() => import("@pages/PaymentHistory"));
// const Home2 = lazy(() => import('@pages/Home2'));
// const Explore = lazy(() => import('@pages/Explore'));
// const Item = lazy(() => import('@pages/Item'));
// const Profile = lazy(() => import('@pages/Profile'));
// const FAQ = lazy(() => import('@pages/FAQ'));
// const Activity = lazy(() => import('@pages/Activity'));
// const ConnectWallet = lazy(() => import('@pages/ConnectWallet'));
// const Team = lazy(() => import('@pages/Team'));
// const BlogSidebar = lazy(() => import('@pages/BlogSidebar'));
// const BlogGrid = lazy(() => import('@pages/BlogGrid'));
// const Post = lazy(() => import('@pages/Post'));
const path = window.location.pathname;

const App = () => {
  useEffect(() => {
    preventDefault();
  }, []);

  const gaKey = process.env.REACT_APP_PUBLIC_GA;
  gaKey && ReactGA.initialize(gaKey);

  return (
    <AuthAPI>
      <BidModalContextAPI>
        <SidebarContextAPI>
          <ScrollToTop />
          {path === "/email-verification" ? (
            <Routes>
              <Route
                path="/email-verification"
                element={<EmailVerification />}
              />
            </Routes>
          ) : (
            <AppLayout>
              <Suspense fallback={<LoadingScreen visible />}>
                <Routes>
                  <Route exact path="/home" element={<Home />} />
                  <Route path="/" element={<CommingSoon />} />
                  <Route path="/creation" element={<ProtectedRoute><ExploreGrid /></ProtectedRoute>} />
                  <Route path="/author" element={<Author />} />
                  <Route path="/tickets" element={<Ranking />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/signup" element={<Signup />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/terms" element={<Policy />} />
                  <Route path="/privacy-policy" element={<Policy />} />
                  <Route path="/cookie-policy" element={<Policy />} />
                  <Route path="/contact-us" element={<Contacts />} />
                  <Route path="/featured-comix" element={<FeaturedComix />} />
                  <Route path="/help-center" element={<Help />} />
                  {/* <Route path="/coming-soon" element={<CommingSoon />} /> */}
                  <Route path="/share" element={<FacebookShare />} />

                  <Route
                    path="/thank-you"
                    element={
                      <ProtectedRoute>
                        <ThankYouPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route path="/interest" element={<ProtectedRoute><Interest /></ProtectedRoute>} />

                  <Route path="/story-board" element={<StoryBoard />} />
                  <Route path="/community" element={<Community />} />
                  <Route
                    path="/credit-payment-history"
                    element={<PaymentHistory />}
                  />
                  <Route
                    path="/password-reset/:id/:token"
                    element={<ForgotPassword />}
                  />
                  <Route path="/invest" element={<Invest />} />
                  <Route path="*" element={<PageNotFound />} />
                  <Route path="/creation/:id" element={<Comic />} />
                  <Route
                    path="/creation/:id/create/:pageNumber"
                    element={<CreatePage />}
                  />

                  <Route
                    path="/creation/:id/edit/:pageNumber"
                    element={<EditPage />}
                  />
                  {/* <Route path="/index2" element={<Home2 />} /> */}
                  {/* <Route path="/explore" element={<Explore />} /> */}
                  {/* <Route path="/explore/item" element={<Item />} /> */}
                  {/* <Route path="/profile" element={<Profile />} /> */}
                  {/* <Route path="/faq" element={<FAQ />} /> */}
                  {/* <Route path="/activity" element={<Activity />} /> */}
                  {/* <Route path="/connect-wallet" element={<ConnectWallet />} /> */}
                  {/* <Route path="/team" element={<Team />} /> */}
                  {/* <Route path="/blog-sidebar" element={<BlogSidebar />} /> */}
                  {/* <Route path="/blog-grid" element={<BlogGrid />} /> */}
                </Routes>
                <CookieComp />
              </Suspense>
            </AppLayout>
          )}
        </SidebarContextAPI>
      </BidModalContextAPI>
    </AuthAPI>
  );
};

export default App;
